// A news post: the header image loads in as pixels; ← → go to the previous or next post, Esc back to all news.
// Ported from the approved concept (concept/src/09-pages.js).
import { $, depixelate, onPageIn } from 'fx';

const page = $('[data-article]');
if (page) {
  const img = $('#a-img', page);
  if (img) onPageIn(() => depixelate(img));

  document.addEventListener('keydown', (e) => {
    if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.altKey || document.documentElement.classList.contains('is-locked')) return;
    if (e.target.closest && e.target.closest('input, textarea, select')) return;
    const link = $(`[data-key="${e.key}"]`, page);
    if (link) { e.preventDefault(); link.click(); }
  });
}
